import React from "react";

type BadgeProps = {
  color?: string;
  counter?: number;
  counterMax?: number;
  top?: number;
  right?: number;
};

const BadgeCounter: React.FC<BadgeProps> = ({
  color = "grey",
  counter = 0,
  top = 0,
  right = 0,
  counterMax = 9,
}) => {
  // Define consistent height + padding
  if (color === "") color = "blue";
  return (<>
    <style>{`
        .badge {
          top: ${top}px;
          right: ${right}px;
          min-width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          position: absolute;
          animation: keyframes-bellIconFadeInAnimation-5-1-11 500ms;
          font-size: 11px;
          border-radius: 50%;
          box-sizing: border-box;
          padding: 0 3px; /* Optional: allows padding if numbers exceed 1 digit so it scales gracefully into an oval */
        }
        .badge.red { background-color: #ed1622; }
        .badge.purple { background-color: #e6bde5; color:black }
        .badge.pink { background-color: #f36493 }
        .badge.indigo { background-color: #9caad8; }
        .badge.cyan { background-color: #bbebf0; color:black }
        .badge.lime { background-color: #d0d962; color:black }
        .badge.orange { background-color: #ff9528; }
        .badge.brown { background-color: #a58b84; }
        .badge.violet { background-color: #7a59bc }
        .badge.dark { background-color: #2b383e }
        .badge.smoke { background-color: #4a6b78 }
        .badge.neon { background-color: #88c241 }
        .badge.light { background-color: #d6d9da; color:black }
        .badge.lightgreen { background-color: #b2e1da; color:black }
        .badge.green { background-color: #43a047; }
        .badge.blue { background-color: #1e88e5; }
        .badge.yellow { background-color: #fbc02d; color: black; }
        .badge.grey { background-color: #757575; }
        .badge.lightgrey { background-color: #e3e3e3; color:black}
        .badge.hex { background-color: ${color}; color: white; }
      `}</style>

    <div className={`badge ${color.startsWith("#") ? "hex" : color}`} style={{ display: counter > 0 ? "flex" : "none" }}>
      {counter > counterMax && counterMax !== 0 ? "9+" : counter}
    </div>
  </>
  );
};

export default BadgeCounter;
